export default "__VITE_ASSET__be250118__"